import styled from '@emotion/styled'

import { Icon } from '@/legacy/components/Icon'
import { BodyM } from '@/legacy/components/Typography'

const ContainerStyles = styled.div`
  .error {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;
    .icon {
      font-size: 0.875rem;
    }
  }
`
const ErrorMessage = () => (
  <ContainerStyles>
    <BodyM className="error et-red-ribbon" emphasys>
      Erro ao avaliar o artigo! <Icon className="icon" icon="error" color="red-ribbon" />
    </BodyM>
    <BodyM color="dark-medium">Tente novamente.</BodyM>
  </ContainerStyles>
)

export default ErrorMessage
